import React from 'react';
import ClipLoader from 'react-spinners/ClipLoader';

const LoadingIndicator = ({ isLoading, color = "#2684fc", size = 50 }) => {
    // 로딩 상태가 아니라면 아무것도 렌더링하지 않음 (조기 반환)
    if (!isLoading) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-[rgba(0,0,0,0.2)] z-50">
            <ClipLoader color={color} size={size} />
        </div>
    );
};

export default LoadingIndicator; 